"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeConfigKeyConst = void 0;
exports.IkeConfigKeyConst = {
    /**
     * Application name
     *
     * @remarks
     *
     * This is used for logging purposes and is generally injected via environment variables
     *
     * @example "@ikegps/server" "@ikegps/bot"
     */
    APPLICATION_NAME: 'application.name',
    /**
     * Application version, generally the build number
     *
     * @example "4032"
     */
    APPLICATION_VERSION: 'application.version',
    /**
     * Full public URL for the application
     *
     * @example "https://staging.office.ikegps.net"
     */
    APPLICATION_URL: 'application.url',
    /**
     * Unique Id for the application
     *
     * @remarks
     * Used for Parse server's ApplicationId
     *
     * @example "dragon-beta" "dragon-production"
     *
     * @deprecated 2019-05-13 (Parse)
     */
    APPLICATION_ID: 'application.id',
    /**
     * Parse server master key
     *
     * @remarks
     * Parse server has been deprecated and is scheduled to be removed in May 2019
     *
     * @deprecated 2019-05-13 (Parse)
     */
    APPLICATION_MASTER: 'application.master',
    /**
     * Path to the Parse API server
     *
     * @example "/parse"
     *
     * @deprecated 2019-05-13 (Parse)
     */
    APPLICATION_API_PATH: 'application.api',
    /**
     * Internal URL to connect to this application
     *
     * @remarks
     * using the public application.url for additional requests was causing DNS timeouts, connection timeouts and other issues
     * Servers now talk to each other using their loopback. even using `localhost` was causing DNS timeouts
     *
     * @example '127.0.0.1:1337'
     *
     */
    APPLICATION_URL_INTERNAL: 'application.url.internal',
    /**
     * ISO Date of when this application was built
     * @example '2019-05-13T03:39:39.656Z'
     */
    APPLICATION_BUILD_DATE: 'application.build.date',
    /**
     * Short hash of the commit that was used to build this application
     *
     * @example '8e6de755'
     */
    APPLICATION_BUILD_COMMIT: 'application.build.commit',
    /**
     * The key for enabling auth0
     */
    AUTH0_ENABLED: 'auth0.enabled',
    /**
     * The client id of the Auth0 application we want to use for this environment
     */
    AUTH0_CLIENT_ID: 'auth0.client.id',
    /**
     * The signing key of the Auth0 API that owns the application
     */
    AUTH0_CLIENT_SECRET: 'auth0.client.secret',
    /**
     * The client id of the backend Auth0 application we want to use for this environment
     */
    AUTH0_OFFICE_BACKEND_CLIENT_ID: 'auth0.office.backend.client.id',
    /**
     * The secret of the backend Auth0 application
     */
    AUTH0_OFFICE_BACKEND_CLIENT_SECRET: 'auth0.office.backend.client.secret',
    /**
     * The custom domain of the Auth0 application  we want to use for this environment
     */
    AUTH0_DOMAIN: 'auth0.domain',
    /**
     * The tenant domain of the Auth0 application  we want to use for this environment
     */
    AUTH0_TENANT_DOMAIN: 'auth0.tenant.domain',
    /**
     * The Audience of the Auth0 application
     */
    AUTH0_AUDIENCE: 'auth0.audience',
    /**
     * AWS KMS key to decrypt `config.store` values with
     */
    CONFIG_KEY: 'config.key',
    /**
     * Parameter store key to load config values from
     *
     * @example 'test' 'production'
     */
    CONFIG_STORE: 'config.store',
    /**
     * Last time the configuration was loaded from the remote store
     *
     * @example Date.now()
     */
    CONFIG_LOADED: 'config.loaded',
    EVENT_BACKBONE_ARN: 'event.backbone.arn',
    /**
     * This is the URL to post events for the IKE Event Bus. This config will likely be removed
     * as when we finally integrate with an ESB or Event Queuing service, we will use an SDK with
     * a connection string, or client id
     */
    EVENT_QUEUE_API_URL: 'event.queue.api.url',
    /**
     * This is the API key for the event queue API. Read the above config item for more details.
     */
    EVENT_QUEUE_API_KEY: 'event.queue.api.key',
    /**
     * S3 Bucket where all test data assets are stored
     *
     * NOTE: This bucket is only used in development and test environments. It is not loaded in staging and production environments.
     */
    TEST_DATA_BUCKET: 'test.data.bucket',
    /**
     * S3 Bucket where all files are stored
     *
     * @example `ike-office-staging`
     */
    STORAGE_BUCKET: 'storage.bucket',
    /**
     * Old storage path
     *
     * @remarks
     * Storage was converted to having a bucket per environment eg `ike-office-test` so these keys are no longer needed
     *
     * @deprecated 2019-05-13 (Storage)
     */
    STORAGE_PATH: 'storage.path',
    /**
     * Prefix for files inside of a bucket
     * @deprecated 2019-05-13 (Storage)
     */
    STORAGE_BUCKET_PREFIX: 'storage.prefix',
    /**
     * S3 Bucket name for private files
     *
     * @deprecated 2019-05-13 (Storage)
     */
    STORAGE_PRIVATE_BUCKET: 'storage.private.bucket',
    /**
     * Public URL path for files inside of the private files bucket
     *
     * @deprecated 2019-05-13 (Storage)
     */
    STORAGE_PRIVATE_PATH: 'storage.private.path',
    /**
     * Prefix for files inside of the private files bucket
     *
     * @deprecated 2019-05-13 (Storage)
     */
    STORAGE_PRIVATE_BUCKET_PREFIX: 'storage.private.prefix',
    /**
     * Public URL path for files
     *
     * @deprecated 2019-05-13 (Storage/Parse)
     */
    STORAGE_URL: 'storage.url',
    /**
     * Enables the swagger documentation page located under `/v1/docs`
     * Is false by default
     */
    SWAGGER_ENABLED: 'swagger.enabled',
    /**
     * Google Maps API key
     * @remarks
     * This is configured inside of google cloud compute
     */
    GOOGLE_MAPS: 'vendor.google.maps',
    /**
     * Google Maps release channel version
     */
    GOOGLE_MAPS_RELEASE_CHANNEL: 'vendor.google.mapsReleaseChannel',
    /**
     * Google Tag Manager key
     */
    GOOGLE_TAG_MANAGER: 'vendor.google.tagmanager',
    /**
     * Google Analytics API key
     */
    GOOGLE_ANALYTICS: 'vendor.google.analytics',
    /**
     * AWS region
     * @example us-east-1
     */
    AWS_REGION: 'aws.region',
    /**
     * Configure the timeout for HTTP connections using the AWS API
     *
     * @remarks
     * We have run into issues where a high timeout caused other connections to timeout (eg CloudFront)
     */
    AWS_TIMEOUT_HTTP: 'aws.timeout.http',
    /**
     * Configure the connection timeout for TCP connections using the AWS API
     * @remarks
     * We have run into issues where AWS connections would hang for no reason, but the next request would connect instantly.
     */
    AWS_TIMEOUT_CONNECT: 'aws.timeout.connect',
    /** Main Database (DocumentDb) connection information */
    DATABASE_USERNAME: 'database.username',
    DATABASE_PASSWORD: 'database.password',
    /**
     * Database hostname
     * @remarks
     * This sometimes contains the port number eg :27017 which has been deprecated as of 2019-05-21
     *
     */
    DATABASE_HOST: 'database.host',
    DATABASE_PORT: 'database.port',
    DATABASE_DATABASE: 'database.database',
    /**
     * TODO this key does not appear to be in use
     * What is its purpose?
     * @deprecated 2019-05-21
     */
    DATABASE_REPLICATION: 'database.replication',
    /**
     * Max time to run database queries
     *
     * @remarks
     * Currently only supports ParseServer Queries
     *
     * @default 15000
     */
    DATABASE_QUERY_TIMEOUT: 'database.query.timeout',
    /**
     * Duration of a query to log at warn level (ms)
     * @default 500
     */
    DATABASE_QUERY_LOG_WARN: 'database.query.log.warn',
    /**
     * Duration of query to log at error level (ms)
     * @default 2500
     */
    DATABASE_QUERY_LOG_ERROR: 'database.query.log.error',
    /**
     * Database replica set to use
     *
     * @example rs0
     */
    DATABASE_REPLICA_SET: 'database.replica',
    /**
     * Database readPreference set to use
     *
     * @example secondaryPreferred
     */
    DATABASE_READ_PREFERENCE: 'database.readpreference',
    /**
     * URL to certificate used for SSL
     * @remarks
     * DocumentDb requires us to import the AWS certificates before being able to connect
     * @example https://s3.amazonaws.com/rds-downloads/rds-combined-ca-bundle.pem
     */
    DATABASE_CERT_URL: 'database.cert.url',
    /** Reporting/Analytic system (Elastic) connection information */
    ELASTIC_USERNAME: 'elastic.username',
    ELASTIC_PASSWORD: 'elastic.password',
    ELASTIC_HOST: 'elastic.host',
    ELASTIC_PORT: 'elastic.port',
    ELASTIC_ENABLED: 'elastic.enabled',
    /** Logging/Monitoring system (Elastic) connection information */
    ELASTIC_MONITOR_USERNAME: 'elastic.monitor.username',
    ELASTIC_MONITOR_PASSWORD: 'elastic.monitor.password',
    ELASTIC_MONITOR_HOST: 'elastic.monitor.host',
    ELASTIC_MONITOR_PORT: 'elastic.monitor.port',
    ELASTIC_MONITOR_ENABLED: 'elastic.monitor.enabled',
    ELASTIC_INDEX_NAME: 'elastic.index.name',
    /** Monitoring system (InfluxDb) connection information */
    MONITOR_HOST: 'monitor.host',
    MONITOR_PORT: 'monitor.port',
    MONITOR_USERNAME: 'monitor.username',
    MONITOR_PASSWORD: 'monitor.password',
    MONITOR_DATABASE: 'monitor.database',
    /**
     * Stream name for client logging
     * @example 'stream-console' 'stream-logentries'
     */
    LOG_CLIENT_STREAM: 'log.client.stream',
    /**
     * Level to log client logs at
     * @example 10 20 30
     */
    LOG_CLIENT_LEVEL: 'log.client.level',
    /**
     * Should the logger log to console
     * @example true
     */
    LOG_CLIENT_CONSOLE: 'log.client.console',
    /**
     * API Key if needed for client logging
     */
    LOG_CLIENT_CONFIG: 'log.client.config',
    /**
     * Level to log lambda function logs at
     * @example 10 20 30
     */
    LOG_FUNCTION_CONSOLE: 'log.function.console',
    /**
     * Level to log lambda function logs at
     * @example 10 20 30
     */
    LOG_FUNCTION_LEVEL: 'log.function.level',
    /**
     * Stream name for lambda function logging
     * @example 'stream-console' 'stream-logentries'
     */
    LOG_FUNCTION_STREAM: 'log.function.stream',
    /**
     * API key for server logging
     */
    LOG_SERVER_CONFIG: 'log.server.config',
    /**
     * Boolean for whether to enable logging to console (stdout/stderr)
     */
    LOG_SERVER_CONSOLE: 'log.server.console',
    /**
     * Stream name for server logging
     * @example 'stream-console' 'stream-logentries'
     */
    LOG_SERVER_STREAM: 'log.server.stream',
    /**
     * Level to log server logs at
     * @example 10 20 30
     */
    LOG_SERVER_LEVEL: 'log.server.level',
    /**
     * Enabling trace timings for request sockets
     */
    TRACE_REQUEST_SOCKET: 'trace.request.socket',
    /**
     * Span-o-matic url
     */
    SOM_URL: 'som.url',
    /**
     * The URL of the IKE Access API
     */
    IKE_ACCESS_API_URL: 'ike.access.api.url',
    /**
     * The audience value for IKE Office to authenticate and consume the IKE Access API
     */
    IKE_ACCESS_API_AUDIENCE: 'ike.access.api.audience',
    /**
     * The ID of the IKE Office performer user
     */
    IKE_ACCESS_API_PERFORMER_ID: 'ike.access.api.performer.id',
    IKE_ACCESS_API_PERFORMER_ORGANIZATION: 'ike.access.api.performer.organization',
    /**
     * Enable license validation caching (default: true)
     */
    IKE_ACCESS_LICENSE_CACHE_ENABLED: 'ike.access.license.cache.enabled',
    /**
     * License validation cache TTL in seconds (default: 3600 = 1 hour)
     */
    IKE_ACCESS_LICENSE_CACHE_TTL_SECONDS: 'ike.access.license.cache.ttl.seconds',
    /**
     * The base URL of the IKE PoleForeman DB Portal API
     */
    IKE_POLEFOREMAN_DB_BASE_URL: 'ike.poleforeman.db.base.url',
    /**
     * API key for IKE PoleForeman DB Portal API
     */
    IKE_POLEFOREMAN_DB_API_KEY: 'ike.poleforeman.db.api.key',
    /**
     * Secrets used to create version ID strings in IKE PokeForeman DB Portal API
     */
    IKE_POLEFOREMAN_DB_CUSTOMER_NAME_CIPHER: 'ike.poleforeman.db.customer.name.cipher',
    IKE_POLEFOREMAN_DB_CUSTOMER_NAME_IV: 'ike.poleforeman.db.customer.name.iv',
    IKE_POLEFOREMAN_DB_CIPHER: 'ike.poleforeman.db.cipher',
    IKE_PUKEKO_API_URL: 'ike.pukeko.api.url',
    IKE_PUKEKO_API_TOKEN: 'ike.pukeko.api.token',
    /**
     * AWS Lambda function names
     */
    AWS_LAMBDA_IKEGPS_BRIGHTNESS: 'aws.lambda.ikegps_brightness',
    AWS_LAMBDA_IKEGPS_COMPOSITE: 'aws.lambda.ikegps_composite',
    AWS_LAMBDA_IKEGPS_COMPRESS: 'aws.lambda.ikegps_compress',
    AWS_LAMBDA_IKEGPS_CROP: 'aws.lambda.ikegps_crop',
    AWS_LAMBDA_IKEGPS_SVG: 'aws.lambda.ikegps_svg',
    AWS_LAMBDA_IKEGPS_THUMBNAIL: 'aws.lambda.ikegps_thumbnail',
    AWS_LAMBDA_IKEGPS_LOCATION: 'aws.lambda.ikegps_location',
    /**
     * Cloud Storage Security username and password for virus scanning
     */
    CLOUD_STORAGE_SEC_USER: 'cloud.storage.sec.user',
    CLOUD_STORAGE_SEC_PASSWORD: 'cloud.storage.sec.password',
};
//# sourceMappingURL=store.keys.js.map